import { ProductType } from '@inter-ikea-storageone/range';
import { showClothHangersSheet as showClothHangersSheetAction } from '../features/ClothHangers/ClothHangersFeature';
import { BehaviorParameters } from 'rangeConfig/@types';
import { allRailProductTypes } from '../utils/clothHangers';
import { e2e } from 'utils/queryUtils';

const showClothHangersSheet = ({ coreApi, dispatch, rootState }: BehaviorParameters) => {
  if (e2e()) return;

  const clothHangersProduct = rootState.products.inMarket.find(
    p => p.type === ProductType.CLOTH_HANGERS
  );

  const clothRailsInScene = coreApi.entities.getByProductTypes(allRailProductTypes).length;
  const clothHangersInScene = coreApi.entities.getByProductType(ProductType.CLOTH_HANGERS).length;

  if (clothHangersProduct && clothRailsInScene && !clothHangersInScene) {
    dispatch(showClothHangersSheetAction());
  }
};

export default showClothHangersSheet;
